import { ChangeDetectionStrategy, Component, HostBinding, input, Input, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TrimInputDirective } from '../../../../shared/directives/trim-input.directive';
import { CoreControlDirective } from '../../../utils/core-control.directive';

@Component({
  selector: 'osp-input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrl: './input-textarea.component.scss',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextareaModule,
    TrimInputDirective,
  ],
  encapsulation: ViewEncapsulation.None,
  providers: CoreControlDirective.coreControlProvider(InputTextareaComponent),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputTextareaComponent extends CoreControlDirective {
  @HostBinding('class.osp-input-textarea') protected hostCssClassEnabled = true;

  @Input() rows: number = 5;
  @Input() cols: number = 30;
  @Input() variant: 'outlined' | 'filled' = 'outlined';
  @Input() placeholder = '';
  @Input() cssClass = '';
  $trimEnabled = input(true, { alias: 'trimEnabled' });
}
